import React, { useState, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import BasicDrawer from '../../BasicDrawer';
import { TAC_STEP_INITIAL } from '../../../../../settings/constants/tac';

const AutoCloseDrawerSecure2u = ({ isOpen, onClose, onChange, state, setState }) => {
  const timerRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      // Saat drawer dibuka, mulai timer auto-close
      timerRef.current = setTimeout(() => {
        onChange({ tacStep: TAC_STEP_INITIAL });
        setState({
          isError: false,
          isDisplay: true,
          isExpired: false,
        }); // panggil fungsi dari parent buat nutup drawer
      }, 5000);
    }

    return () => {
      // Bersihin timer saat drawer tutup atau komponen unmount
      clearTimeout(timerRef.current);
    };
  }, [isOpen, onClose]);

  return (
    <BasicDrawer className="error" isOpen={isOpen} hideBackdrop={false} onClose={onClose}>
      <h1 className="white f5 lh-copy mb0 tc">
        <FormattedMessage id="secure2u.expired" />
      </h1>
    </BasicDrawer>
  );
};

AutoCloseDrawerSecure2u.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AutoCloseDrawerSecure2u;
